import React, { useState } from "react";
import { FaClipboardCheck } from "react-icons/fa";
import PageHeader from "../../../core/common/header/PageHeader";
import AdminClassTestList from "./AdminClassTestList";
import AdminClassTestEditor from "./AdminClassTestEditor";
import AdminClassTestAssignments from "./AdminClassTestAssignments";
import AdminClassTestGrade from "./AdminClassTestGrade";
import AdminClassTestOverview from "./AdminClassTestOverview";

type Tab = "tests" | "editor" | "assignments" | "grade" | "overview";

const AdminClassTestManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>("tests");
  const [editingTestId, setEditingTestId] = useState<number | null>(null);
  const [gradingAssignmentId, setGradingAssignmentId] = useState<number | null>(null);

  const openEditor = (id: number | null) => {
    setEditingTestId(id);
    setActiveTab("editor");
  };

  const openGrade = (assignmentId: number) => {
    setGradingAssignmentId(assignmentId);
    setActiveTab("grade");
  };

  const tabs: { key: Tab; label: string }[] = [
    { key: "tests", label: "Class Tests" },
    { key: "assignments", label: "Assignments" },
    { key: "overview", label: "Score Overview" },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <PageHeader
        icon={<FaClipboardCheck />}
        title="Class Test Management"
        breadcrumb={[
          { label: "Home", to: "/" },
          { label: "Dashboard", to: "/admin/dashboard" },
          { label: "Class Tests" },
        ]}
      />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        {activeTab !== "editor" && activeTab !== "grade" && (
          <div className="bg-white rounded-lg shadow-sm mb-6 border border-gray-200">
            <div className="flex border-b border-gray-200 overflow-x-auto">
              {tabs.map((t) => (
                <button
                  key={t.key}
                  onClick={() => setActiveTab(t.key)}
                  className={`px-6 py-4 font-medium transition-colors whitespace-nowrap ${
                    activeTab === t.key
                      ? "text-[#009fe3] border-b-2 border-[#009fe3] bg-blue-50"
                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {activeTab === "tests" && (
          <AdminClassTestList onEdit={openEditor} onNew={() => openEditor(null)} />
        )}
        {activeTab === "editor" && (
          <AdminClassTestEditor
            classTestId={editingTestId}
            onBack={() => setActiveTab("tests")}
          />
        )}
        {activeTab === "assignments" && (
          <AdminClassTestAssignments onGrade={openGrade} />
        )}
        {activeTab === "grade" && gradingAssignmentId && (
          <AdminClassTestGrade
            assignmentId={gradingAssignmentId}
            onBack={() => setActiveTab("assignments")}
          />
        )}
        {activeTab === "overview" && <AdminClassTestOverview />}
      </main>
    </div>
  );
};

export default AdminClassTestManagement;
